import { CanActivate, GuardResult, MaybeAsync, Router } from '@angular/router';
import { Auth, authState, User } from '@angular/fire/auth';
import { inject, Injectable } from '@angular/core';
import { map, take, tap } from 'rxjs/operators';

@Injectable()
export class AuthenticatedGuard implements CanActivate {
  afAuth = inject(Auth);
  router = inject(Router);
  authState$ = authState(this.afAuth);
  canActivate(): MaybeAsync<GuardResult> {
    return this.authState$.pipe(
      map((user: User | null) => user?.emailVerified === true),
      take(1),
      tap((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          this.router.navigate(['/login']);
        }
      }),
    );
  }
}
